// extracted by mini-css-extract-plugin
export default {"shadow":"JustShadow_shadow__NgMLH"};